import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import { v4 as uuidv4 } from 'uuid';
import GenerarUsuariosComponent from './GenerarUsuariosComponent'
import { obtenerUsuariosOCNacional } from '../../../../redux/DuckOrganismoCertificacion/GenerarUsuariosDuck'
import { agregarUsuarioOC, actualizarUsuarioOC } from '../../../../redux/DuckOrganismoCertificacion/GenerarUsuariosDuck'
import moment from 'moment'

function UsuariosOCNacionalComponent(props) {

    const dispatch = useDispatch()
    const [usuarios, setUsuarios] = useState([])//useSelector(store => store.GenerarUsuarios.usuarios));

    React.useEffect(async () => {
        let res = await dispatch(obtenerUsuariosOCNacional(7))
        setUsuarios(res?.payload)
    }, [])


    /******Modal */
    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [idUser, setIdUser] = React.useState('')
    const handleOpenModal = (data) => {
        //setTitleModal(data?.title)
        setBodyModal(data)
        //setAccion(data?.accion)
        //setIdUser(data?.usuario)
        setOpenModal(true)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setIdUser('')
        setOpenModal(false)
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        height: 'fit-content',
        bgcolor: 'background.paper',
        border: 'none',
        boxShadow: 24,
        padding: '2% 3% 0 3%'
    };

    const modalComponent = () => {
        return (
            <div>
                <Modal open={openModal} onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description" >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" style={{ color: "#F30707" }}>
                            <center><strong>{titleModal}</strong></center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }} style={{ color: "black", textAlign: 'justify' }}>
                            <GenerarUsuariosComponent functionAcept={botonAgregarUsuario} usuarioModify={bodyModal} functionActualizar={botonActualizarUsuario} ></GenerarUsuariosComponent>
                        </Typography>
                        <br />
                    </Box>
                </Modal>
            </div>
        )
    }

    const botonEliminar = async (id) => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de eliminar un usuario, esta acción no se podrá revertir.`,
            accion: 'eliminar',
            usuario: id,
        })
    }

    let rows = []
    let numUser = 1
    for (const i in usuarios) {
        let { ...usuario } = usuarios[i]
        let puestoUser = null
        if (usuario.puesto == 'Auxiliar Nacional') puestoUser = 'Auxiliar Nacional'
        rows.push({
            num: numUser, id: `${usuario?.idlogin}`, nombre: usuario?.nombre + ' ' + usuario?.apellidos, puesto: usuario?.idrol == 7 ? 'Auxiliar Nacional' : '', usuario: usuario?.usuario,
            telefono: usuario?.telefono, apellidos: usuario?.apellidos, password: usuario.password
        })
        numUser++
    }


    const columns = [
        { field: 'num', headerAlign: 'center', headerName: 'N°', width: 100 },
        { field: 'usuario', headerAlign: 'center', headerName: 'Usuario', width: 550 },
        { field: 'puesto', headerAlign: 'center', headerName: 'Puesto', width: 400 },
        {
            field: 'accion', headerAlign: 'center', headerName: 'Acción', width: 200,
            renderCell: (params) =>
                <Tooltip title="Editar usuario"><IconButton onClick={() => handleOpenModal(params.row)} fontSize="large" sx={{ color: '#DB3D1A' }} > <BorderColorRoundedIcon /></IconButton></Tooltip>
        },
    ]
    const botonAgregarUsuario = async (dataForm) => {
        const fechaHoy = moment().format('YYYY-MM-DD')
        dataForm.idtipousuario = Number(8)
        dataForm.fechainscripcion = new Date(fechaHoy).toISOString()
        delete dataForm?.id
        let res = await dispatch(agregarUsuarioOC(dataForm))
        setUsuarios([...usuarios, res?.payload?.nuevoUsuario]);
        setOpenModal(false)
    }

    const botonActualizarUsuario = async (dataForm) => {
        dataForm.idlogin = Number(dataForm.id)
        dataForm.idtipousuario = Number(8)
        delete dataForm.id
        let actualizar = await dispatch(actualizarUsuarioOC(dataForm))
        const updatedFields = usuarios.map(usuario => usuario?.idlogin == Number(actualizar?.payload?.idlogin) ? { ...actualizar?.payload } : { ...usuario });
        setUsuarios(updatedFields);
        setOpenModal(false)

    }

    function QuickSearchToolbar() {
        return (
            <Box sx={{ p: 0.5, pb: 0, mb: 2, textAlign: 'left', height: 30, width: '100%', backgroundColor: 'white' }}>
                <GridToolbarQuickFilter style={{ backgroundColor: '#F8F9F9', width: '100%' }} placeholder='Búsqueda...' />
            </Box>
        );
    }

    return (
        <Fragment>
            <div className='container'>
                <h3 style={{ fontFamily: 'Montserrat', marginTop: '6%' }}> <center> <b>USUARIOS AUXILIARES ORGANISMO DE CERTIFICACIÓN NACIONAL</b> </center> </h3>
                <div className='text-end'><button className='btn btn-outline-success' onClick={() => handleOpenModal()} >Agregar usuario</button></div>
                <div style={{ height: 600, width: '100%', marginTop: '2%' }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={10}
                        getRowId={(row) => row.id}
                        rowsPerPageOptions={[7]}
                        components={{ Toolbar: QuickSearchToolbar }}
                        sx={{
                            boxShadow: 0,
                            color: 'black',
                            border: 0,
                            '& .MuiDataGrid-cell': {
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontFamily: 'Montserrat',
                                verticalAlign: 'middle !important'
                            },
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#0C365A',
                                color: 'white',
                                fontFamily: 'Montserrat',
                                fontWeight: 'bold',
                                height: '20px'
                            }
                        }}
                    />
                </div>
            </div>
            {modalComponent()}

        </Fragment>
    );
};

export default withRouter(UsuariosOCNacionalComponent)